/**
 * Format functions for form fields
 * These functions provide standardized formatting for common form inputs
 */

/**
 * Formats a phone number as (123) 456-7890
 * @param value The input phone number string
 * @returns Formatted phone number
 */
export const formatPhoneNumber = (value: string): string => {
  // Strip all non-numeric characters
  const numbers = value.replace(/\D/g, "");
  
  // Limit to 10 digits
  const truncated = numbers.substring(0, 10);
  
  // Format based on length
  if (truncated.length === 0) {
    return "";
  } else if (truncated.length <= 3) {
    return `(${truncated}`;
  } else if (truncated.length <= 6) {
    return `(${truncated.slice(0, 3)}) ${truncated.slice(3)}`;
  } else {
    return `(${truncated.slice(0, 3)}) ${truncated.slice(3, 6)}-${truncated.slice(6)}`;
  }
};

/**
 * Formats a ZIP code as 12345 or 12345-6789
 * @param value The input ZIP code string
 * @returns Formatted ZIP code
 */
export const formatZipCode = (value: string): string => {
  // Only allow digits
  const digits = value.replace(/\D/g, "");
  
  // Limit to 9 digits (ZIP or ZIP+4)
  const truncated = digits.substring(0, 9);
  
  // Format as ZIP or ZIP+4
  if (truncated.length <= 5) {
    return truncated;
  } else {
    return `${truncated.slice(0, 5)}-${truncated.slice(5)}`;
  }
};

/**
 * Formats a URL by ensuring it has a proper protocol prefix
 * @param url The input URL string
 * @returns Formatted URL with protocol
 */
export const formatUrl = (url: string): string => {
  if (!url) return url;
  
  // If the URL doesn't start with a protocol, add https://
  if (!/^https?:\/\//i.test(url)) {
    return `https://${url}`;
  }
  
  return url;
}; 